import React, { useCallback, useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const HeroCarousel = () => {
  const images = [
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/jzcy4zxk_Hair%20extensions%20training%20coursestraining%20courses_20260109_152647_0002.png',
      alt: 'Hair Extensions Training Courses'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/qnfwtdnz_Hair%20extensions%20training%20coursestraining%20courses_20260109_152647_0003.png',
      alt: 'Cranial Prosthesis Consultant Training'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/dt2im43v_Banners%20for%20blogs%20%20A%20Double%20Standard%20for%20Black%20Entrepreneurs_20251109_170450_0001.png',
      alt: 'Professional Hair Extensions Academy'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/qosxi4gh_Banners%20for%20blogs%20%20A%20Double%20Standard%20for%20Black%20Entrepreneurs_20251109_170450_0002.png',
      alt: 'Award-Winning Training Academy'
    }
  ];

  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, duration: 30 },
    [Autoplay({ delay: 4000, stopOnInteraction: false })]
  );

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <div className="hero-carousel-container">
      <div className="embla" ref={emblaRef}>
        <div className="embla__container">
          {images.map((image, index) => (
            <div className="embla__slide" key={index}>
              <img
                src={image.url}
                alt={image.alt}
                className="carousel-image"
                loading={index === 0 ? 'eager' : 'lazy'}
              />
            </div>
          ))}
        </div>
      </div>

      <button
        className="carousel-button carousel-button-prev"
        onClick={scrollPrev}
        aria-label="Previous slide"
      >
        <ChevronLeft size={32} />
      </button>

      <button
        className="carousel-button carousel-button-next"
        onClick={scrollNext}
        aria-label="Next slide"
      >
        <ChevronRight size={32} />
      </button>
    </div>
  );
};

export default HeroCarousel;